import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import {
  getTokenImageSrc,
  validateImage,
  getShortAddress,
  formatNumberWithComma,
  getChainName,
  getEcosystemName,
} from "features/helpers/utils";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { useTheme } from "@mui/material";

export default function useGetTokenHoldingTable() {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const headers = [
    {
      title: "Token Name",
      label: formatMessage({ id: "global.commonWord.tokenName" }),
      id: "tokenName",
      show: true,
      disabledSort: true,
    },
    {
      title: "Balance",
      label: (
        <Box display="flex" alignItems="center" gap={"2px"}>
          {formatMessage({ id: "global.commonWord.balance" })}
          <IconTooltip
            content={formatMessage({
              id: "cdp.userProfileOnChainData.walletBalance.tooltip",
            })}
          />
        </Box>
      ),
      id: "balance",
      show: true,
    },
    {
      title: "Value",
      label: formatMessage({ id: "global.commonWord.value" }),
      id: "value",
      show: true,
    },
    {
      title: "Ecosystem",
      label: formatMessage({ id: "global.commonWord.ecosystem" }),
      id: "ecosystem",
      show: true,
      disabledSort: true,
    },
    {
      title: "Chain",
      label: formatMessage({ id: "global.commonWord.chain" }),
      id: "chain",
      show: true,
      disabledSort: true,
    },
    {
      title: "Wallet Address",
      label: formatMessage({ id: "global.commonWord.walletAddress" }),
      id: "walletAddress",
      show: true,
      disabledSort: true,
    },
  ];

  const renderContents = (tokenData) => {
    const inPinned = tokenData.pinned ? true : false;

    return [
      <div slot="tokenName">
        <Box display="flex" alignItems="center" gap="8px">
          <img
            src={getTokenImageSrc(tokenData.token)}
            onError={(e) => {
              e.currentTarget.src =
                require("assets/img/empty-token.svg").default;
            }}
            alt={tokenData.token.name}
            style={{ width: 20, height: 20, marginRight: 8 }}
          />
          {tokenData.token.name || "-"}
          {inPinned && (
            <Box
              sx={{
                color: theme.customColors.purple[500],
                display: "flex",
                alignItems: "center",
              }}
            >
              <i className="meta-crm-icon-ic_pin font-size-13" />
            </Box>
          )}
        </Box>
      </div>,
      <div slot="balance">{formatNumberWithComma(tokenData.balance, 2)}</div>,
      <div slot="value">
        {tokenData.value ? "$" + formatNumberWithComma(tokenData.value) : "-"}
      </div>,
      <div slot="ecosystem">
        {getEcosystemName(tokenData.ecosystem) || "-"}
      </div>,
      <div slot="chain">{getChainName(tokenData.token.chainId) || "-"}</div>,
      <div slot="walletAddress">
        {getShortAddress(tokenData.walletAddress)}
      </div>,
    ];
  };

  return {
    headers,
    renderContents,
  };
}
